import { LineWarning } from '@app/shared';

/** Предупреждение документа: `lineNo` 0 — относится к документу целиком. */
export interface WarningEntry {
  lineNo: number;
  code: string;
}

/**
 * Тексты предупреждений документа (§1, §5, §8.1, §11) — единственное место, где код
 * превращается в слова. Предупреждение не запрещает проведение, а объясняет, что не так и что
 * будет с учётом.
 */
const WARNING_TEXT: Record<LineWarning, string> = {
  [LineWarning.STOCK_NEGATIVE]: 'товара не хватает — остаток уходит в минус',
  [LineWarning.PCS_PER_BOX_DIFFERS]: 'штук в коробке не столько, сколько принято для товара',
  [LineWarning.OVER_BASE]: 'возвращено больше, чем было в документе-основании',
  [LineWarning.NO_BASE]: 'возврат без документа-основания',
  [LineWarning.ARCHIVED_CATEGORY]: 'товар в архиве — с ним документ не провести',
  [LineWarning.COUNTERPARTY_ARCHIVED]: 'контрагент в архиве',
  [LineWarning.PROVISIONAL_COST]: 'себестоимость предварительная: товара не хватило, взята последняя закупочная цена',
  [LineWarning.NO_PURCHASE_PRICE]: 'себестоимость не определена: товар ни разу не закупался',
};

function isKnown(code: string): code is LineWarning {
  return code in WARNING_TEXT;
}

function capitalize(text: string): string {
  return text.charAt(0).toUpperCase() + text.slice(1);
}

export function warningText(code: string): string {
  return isKnown(code) ? WARNING_TEXT[code] : code;
}

/** «Строка 2 — «Чипсы»: товара не хватает — остаток уходит в минус». Название товара берётся из
 * строк окна: сервер присылает только номер строки. */
export function describeWarning(entry: WarningEntry, lineName?: string): string {
  const text = warningText(entry.code);
  if (entry.lineNo === 0) return capitalize(text);
  const where = lineName ? `Строка ${entry.lineNo} — «${lineName}»` : `Строка ${entry.lineNo}`;
  return `${where}: ${text}`;
}

/** Все предупреждения документа строками текста, в порядке строк документа. */
export function describeWarnings(entries: WarningEntry[], nameOfLine: (lineNo: number) => string | undefined): string[] {
  return [...entries].sort((a, b) => a.lineNo - b.lineNo).map((entry) => describeWarning(entry, nameOfLine(entry.lineNo)));
}
